import { useTranslation } from 'react-i18next'
import { Box, Button, List, ListItem, ListItemText, Typography } from '@mui/material'

import { IApprovalFeedbacksBaseWithId, IItemDetails } from 'src/types'

import { useStyles } from './../styles'
import { Loader } from 'src/components/loader'
import { ModalWrapper } from 'src/components/modal-wrapper'
import { useState } from 'react'
import { ApproveFeedbacksSelect } from './approve-feedbacks-select.component'

interface IProps {
  options: IApprovalFeedbacksBaseWithId[]
  open: boolean
  handleClose: () => void
  itemsDetails: IItemDetails[]
  handleConfirm: (items: string[]) => void
  isLoadingModal: boolean
}

export const ConfirmApproveModal = ({
  options,
  open,
  handleClose,
  itemsDetails = [],
  handleConfirm,
  isLoadingModal,
}: IProps) => {
  const [t] = useTranslation()
  const classes = useStyles()

  const [itemsIds, setItemsIds] = useState<string[]>([])

  const handleConfirmClick = async () => {
    if (handleConfirm) {
      await handleConfirm(itemsIds)
    }
    handleClose()
    setItemsIds([])
  }

  const handleCloseClick = () => {
    setItemsIds([])
    handleClose()
  }

  return (
    <ModalWrapper open={open} onClose={handleCloseClick} className={classes.modalWrapper}>
      <div style={{ width: '100%', maxWidth: '100%' }}>
        <Typography className={classes.title}>Confirm Approve</Typography>

        {itemsDetails.length > 0 && (
          <List dense>
            {itemsDetails.map(({ title, text }) => (
              <ListItem key={title} sx={{ display: 'block' }} disableGutters>
                <ListItemText
                  primaryTypographyProps={{ className: classes.itemTitle }}
                  primary={`${title}:`}
                />
                <Typography className={classes.relationsTitle}>{text}</Typography>
              </ListItem>
            ))}
          </List>
        )}
        <Box sx={{ width: '100%', maxWidth: '100%', mb: '25px' }}>
          <ApproveFeedbacksSelect
            label={'Feedback'}
            onChange={setItemsIds}
            options={options}
            selected={itemsIds}
          />
        </Box>
      </div>
      <div className={classes.buttonsWrapper}>
        <div className={classes.buttonWrapper}>
          <Button fullWidth variant="outlined" onClick={handleCloseClick} disabled={isLoadingModal}>
            {t('cancel-button-text.v')}
          </Button>
        </div>
        <div className={classes.buttonWrapper}>
          <Button
            fullWidth
            variant="contained"
            onClick={handleConfirmClick}
            disabled={isLoadingModal}
          >
            <Typography sx={{ mr: isLoadingModal ? '8px' : 0 }}>Confirm</Typography>

            {isLoadingModal && <Loader isStatic size={18} />}
          </Button>
        </div>
      </div>
    </ModalWrapper>
  )
}
